import FilterCRHoatchat from "../components/common/filter/crhoatchat/FilterCRHoatchat";
import FilterCRHC from "../components/common/filter/crhc/FilterCRHC";
import FilterCRThuoc from "../components/common/filter/crthuoc/FilterCRThuoc";
import FilterCRVtyt from "../components/common/filter/crvtyt/FilterCRVtyt";
import FilterCustomer from "../components/common/filter/customer/FilterCustomer";
import FilterCRNhomthuoc from "../components/common/filter/crnhomthuoc/FilterCRNhomthuoc";
import { ListType } from "../types/list.type";
import { formatDateDisplay, numeralCustom } from "./helpers";
import FilterCRDuongdung from "../components/common/filter/crduongdung/FilterCRDuongdung";
import FilterCRNsx from "../components/common/filter/crnsx/FilterCRNsx";
import FormCRThuoc from "../components/common/form/crthuoc/FormCRThuoc";
import FormCRVTYT from "../components/common/form/crvtyt/FormCRVTYT";
import moment from "moment";

const lists: { [key: string]: ListType } = {
  customer: {
    title: "Danh sách khách hàng",
    formTitle: "khách hàng",
    apiCode: "customer",
    Filter: FilterCustomer,
    generateCondition(filter) {
      const condition: any[] = [];
      if (filter.ma_kh) {
        condition.push({
          ma_kh: { $regex: filter.ma_kh, $options: "i" },
        });
      }
      if (filter.ten_kh) {
        condition.push({
          ten_kh: { $regex: filter.ten_kh, $options: "i" },
        });
      }
      if (filter.dien_thoai) {
        condition.push({
          dien_thoai: { $regex: filter.dien_thoai, $options: "i" },
        });
      }
      if (filter.email) {
        condition.push({
          email: { $regex: filter.email, $options: "i" },
        });
      }
      if (filter.ten_nh_kh) {
        condition.push({
          ten_nh_kh: { $regex: filter.ten_nh_kh, $options: "i" },
        });
      }
      return condition;
    },
    columns: [
      {
        name: "Mã",
        reorder: true,
        selector: (row) => row.ma_kh,
        width: "120px",
      },
      {
        name: "Tên",
        reorder: true,
        selector: (row) => row.ten_kh,
        width: "200px",
      },
      {
        name: "Email",
        reorder: true,
        selector: (row) => row.email,
        width: "200px",
      },
      {
        name: "Điện thoại",
        reorder: true,
        selector: (row) => row.dien_thoai,
        width: "120px",
      },
      {
        name: "Nhóm khách",
        reorder: true,
        selector: (row) => row.ten_nh_kh,
        width: "200px",
      },
      {
        name: "Ghi chú",
        reorder: true,
        selector: (row) => row.dien_giai,
        width: "200px",
      },
    ],
  },
  cr_thuoc: {
    title: "Thuốc",
    formTitle: "thuốc",
    formWidth: "1000px",
    apiCode: "cr_thuoc",
    allowCreate: true,
    fastFields: [
      { label: "Tên thuốc", value: "ten_thuoc" },
      { label: "Tên hoạt chất", value: "hoat_chat" },
      { label: "Hàm lượng", value: "hamluong" },
      { label: "GĐKLH hoặc GPNK", value: "gdklh" },
      { label: "Đường dùng", value: "duongdung" },
      { label: "Dạng bào chế", value: "baoche" },
      { label: "Nhóm thuốc", value: "nhomthuoc" },
      { label: "Cơ sở sản xuất", value: "cssx" },
      { label: "Nước sản xuất", value: "nuocsx" },
      { label: "Quy cách", value: "quycach" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Số quyết định", value: "soquyetdinh" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    fields: [
      { label: "Tên thuốc", value: "ten_thuoc" },
      { label: "Tên hoạt chất", value: "hoat_chat" },
      { label: "Hàm lượng", value: "hamluong" },
      { label: "GĐKLH hoặc GPNK", value: "gdklh" },
      // { label: "Đường dùng", value: "duongdung" },
      // { label: "Dạng bào chế", value: "baoche" },
      // { label: "Nhóm thuốc", value: "nhomthuoc" },
      // { label: "Cơ sở sản xuất", value: "cssx" },
      // { label: "Nước sản xuất", value: "nuocsx" },
      // { label: "Quy cách", value: "quycach" },
      // { label: "Đơn vị tính", value: "dvt" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      // { label: "Tên CĐT", value: "cdt" },
      { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      // { label: "Số quyết định", value: "soquyetdinh" },
      { label: "Ngày quyết định", value: "ngayquyetdinh" },
      // { label: "Số nhà thầu tham dự", value: "slnhathau" },
      // { label: "Địa điểm", value: "diadiem" },
    ],
    generateCondition(filter) {
      const condition = [];
      if (filter.ten_thuoc) {
        condition.push({
          ten_thuoc: { $regex: filter.ten_thuoc, $options: "i" },
        });
      }
      if (filter.hoat_chat) {
        condition.push({
          hoat_chat: { $regex: filter.hoat_chat, $options: "i" },
        });
      }
      if (filter.hamluong) {
        condition.push({
          hamluong: { $regex: filter.hamluong, $options: "i" },
        });
      }
      if (filter.gdklh) {
        condition.push({
          gdklh: { $regex: filter.gdklh, $options: "i" },
        });
      }
      if (filter.duongdung) {
        condition.push({
          duongdung: { $regex: filter.duongdung, $options: "i" },
        });
      }
      if (filter.baoche) {
        condition.push({
          baoche: { $regex: filter.baoche, $options: "i" },
        });
      }
      if (filter.nhomthuoc) {
        condition.push({
          nhomthuoc: { $regex: filter.nhomthuoc, $options: "i" },
        });
      }
      if (filter.cssx) {
        condition.push({
          cssx: { $regex: filter.cssx, $options: "i" },
        });
      }
      if (filter.nuocsx) {
        condition.push({
          nuocsx: { $regex: filter.nuocsx, $options: "i" },
        });
      }
      if (filter.quycach) {
        condition.push({
          quycach: { $regex: filter.quycach, $options: "i" },
        });
      }
      if (filter.dvt) {
        condition.push({
          dvt: { $regex: filter.dvt, $options: "i" },
        });
      }
      if (filter.tbmt) {
        condition.push({
          tbmt: { $regex: filter.tbmt, $options: "i" },
        });
      }
      if (filter.cdt) {
        condition.push({
          cdt: { $regex: filter.cdt, $options: "i" },
        });
      }
      if (filter.soquyetdinh) {
        condition.push({
          soquyetdinh: { $eq: filter.soquyetdinh },
        });
      }
      if (filter.slnhathau) {
        condition.push({
          slnhathau: { $eq: filter.slnhathau },
        });
      }
      if (filter.diadiem) {
        condition.push({
          diadiem: { $regex: filter.diadiem, $options: "i" },
        });
      }
      if (filter.ngayquyetdinhFrom || filter.ngayquyetdinhTo) {
        const startDate = moment(filter.ngayquyetdinhFrom)
          .hours(0)
          .minutes(0)
          .seconds(0);
        const endDate = moment(filter.ngayquyetdinhTo)
          .hours(23)
          .minutes(59)
          .seconds(59);
        if (filter.ngayquyetdinhFrom && filter.ngayquyetdinhTo) {
          condition.push({
            ngayquyetdinh: { $gte: startDate, $lte: endDate },
          });
        } else if (filter.timeFrom) {
          condition.push({ ngayquyetdinh: { $gte: startDate } });
        } else if (filter.timeTo) {
          condition.push({ ngayquyetdinh: { $lte: endDate } });
        }
      }
      return condition;
    },
    Filter: FilterCRThuoc,
    Form: FormCRThuoc,
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thuốc",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_thuoc,
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hoat_chat,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hamluong,
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.gdklh,
      },
      {
        name: "Đường dùng",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.duongdung,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.baoche,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhomthuoc,
      },
      {
        name: "Cơ sở SX",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cssx,
      },
      {
        name: "Nước SX",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nuocsx,
      },
      {
        name: "Quy cách",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.quycach,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Số lượng",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Đơn giá",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "210px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soquyetdinh,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayquyetdinh,
        format: (row) => formatDateDisplay(row.ngayquyetdinh, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
        format: (row) => numeralCustom(row.slnhathau).format(),
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  cr_vtyt: {
    title: "Vật tư y tế",
    formTitle: "vật tư y tế",
    apiCode: "cr_vtyt",
    allowCreate: false,
    fields: [
      { label: "Tên thiết bị", value: "ten_vtyt" },
      { label: "Đơn vị tính", value: "dvt" },
      // { label: "Khối lượng", value: "soluong" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      // { label: "Mã hồ sơ", value: "mahs" },
      // { label: "Chủng loại", value: "model" },
      // { label: "Số lưu hành", value: "soluuhanh" },
      // { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      // { label: "Tên CĐT", value: "cdt" },
      // { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      // { label: "Số quyết định", value: "sqd" },
      // { label: "Địa điểm", value: "diadiem" },
    ],
    fastFields: [
      { label: "Tên thiết bị", value: "ten_vtyt" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    Form: FormCRVTYT,
    generateCondition: (filter) => {
      const condition = [];
      if (filter.ten_vtyt) {
        condition.push({
          ten_vtyt: { $regex: filter.ten_vtyt, $options: "i" },
        });
      }
      if (filter.dvt) {
        condition.push({
          dvt: { $regex: filter.dvt, $options: "i" },
        });
      }
      if (filter.xuatxu) {
        condition.push({
          xuatxu: { $regex: filter.xuatxu, $options: "i" },
        });
      }
      if (filter.nhanhieu) {
        condition.push({
          nhanhieu: { $regex: filter.nhanhieu, $options: "i" },
        });
      }
      if (filter.kyhieu) {
        condition.push({
          kyhieu: { $regex: filter.kyhieu, $options: "i" },
        });
      }
      if (filter.hsx) {
        condition.push({
          hsx: { $regex: filter.hsx, $options: "i" },
        });
      }
      if (filter.mahs) {
        condition.push({
          mahs: { $regex: filter.mahs, $options: "i" },
        });
      }
      if (filter.model) {
        condition.push({
          model: { $regex: filter.model, $options: "i" },
        });
      }
      if (filter.soluuhanh) {
        condition.push({
          soluuhanh: { $regex: filter.soluuhanh, $options: "i" },
        });
      }
      if (filter.cauhinhkythuat) {
        condition.push({
          cauhinhkythuat: { $regex: filter.cauhinhkythuat, $options: "i" },
        });
      }
      if (filter.tbmt) {
        condition.push({
          tbmt: { $regex: filter.tbmt, $options: "i" },
        });
      }
      if (filter.cdt) {
        condition.push({
          cdt: { $regex: filter.cdt, $options: "i" },
        });
      }
      if (filter.sqd) {
        condition.push({
          sqd: { $regex: filter.sqd, $options: "i" },
        });
      }
      if (filter.diadiem) {
        condition.push({
          diadiem: { $regex: filter.diadiem, $options: "i" },
        });
      }
      if (filter.ngayqdFrom || filter.ngayqdTo) {
        const startDate = moment(filter.ngayqdFrom)
          .hours(0)
          .minutes(0)
          .seconds(0);
        const endDate = moment(filter.ngayqdTo)
          .hours(23)
          .minutes(59)
          .seconds(59);
        if (filter.ngayqdFrom && filter.ngayqdTo) {
          condition.push({
            ngayqd: { $gte: startDate, $lte: endDate },
          });
        } else if (filter.timeFrom) {
          condition.push({ ngayqd: { $gte: startDate } });
        } else if (filter.timeTo) {
          condition.push({ ngayqd: { $lte: endDate } });
        }
      }
      return condition;
    },
    Filter: FilterCRVtyt,
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thiết bị",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_vtyt,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Khối lượng",
        width: "130px",
        reorder: true,
        right: true,
        sortable: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Đơn giá",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Xuất xứ",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.xuatxu,
      },
      {
        name: "Nhãn hiệu",
        width: "130px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhanhieu,
      },
      {
        name: "Ký mã hiệu",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.kyhieu,
      },
      {
        name: "Hãng SX",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hsx,
      },
      {
        name: "Mã hồ sơ",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.mahs,
      },
      {
        name: "Chủng loại",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.model,
      },
      {
        name: "Số lưu hành",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soluuhanh,
      },
      {
        name: "Năm sản xuất",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.namsx,
        format: (row) => formatDateDisplay(row.namsx, "DD/MM/YYYY"),
      },
      {
        name: "Cấu hình",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cauhinhkythuat,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "220px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
      name: "Số QĐ",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.sqd,
      },
      {
        name: "Nội dung QĐ",
        width: "200px",
        sortable: true,
        selector: (row) => row.ndqd,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayqd,
        format: (row) => formatDateDisplay(row.ngayqd, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
      },
      {
        name: "Địa điểm",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  cr_hc: {
    title: "Hóa chất",
    formTitle: "hóa chất",
    apiCode: "cr_hc",
    allowCreate: false,
    fields: [
      { label: "Tên hóa chất", value: "ten_hc" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Khối lượng", value: "soluong" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Đơn giá", value: "dongia" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Ngày đăng tải KQLCNT", value: "ngay_kqlcnt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    fastFields: [
      { label: "Tên hóa chất", value: "ten_hc" },
      { label: "Đơn vị tính", value: "dvt" },
      { label: "Xuất xứ", value: "xuatxu" },
      { label: "Nhãn hiệu", value: "nhanhieu" },
      { label: "Ký mã hiệu", value: "kyhieu" },
      { label: "Hãng sản xuất", value: "hsx" },
      { label: "Mã hồ sơ", value: "mahs" },
      { label: "Chủng loại", value: "model" },
      { label: "Số lưu hành", value: "soluuhanh" },
      { label: "Cấu hình kỹ thuật", value: "cauhinhkythuat" },
      { label: "Mã TBMT", value: "tbmt" },
      { label: "Tên CĐT", value: "cdt" },
      { label: "Số quyết định", value: "sqd" },
      { label: "Địa điểm", value: "diadiem" },
    ],
    generateCondition: (filter) => {
      const condition = [];
      if (filter.ten_hc) {
        condition.push({
          ten_hc: { $regex: filter.ten_hc, $options: "i" },
        });
      }
      if (filter.dvt) {
        condition.push({
          dvt: { $regex: filter.dvt, $options: "i" },
        });
      }
      if (filter.xuatxu) {
        condition.push({
          xuatxu: { $regex: filter.xuatxu, $options: "i" },
        });
      }
      if (filter.nhanhieu) {
        condition.push({
          nhanhieu: { $regex: filter.nhanhieu, $options: "i" },
        });
      }
      if (filter.kyhieu) {
        condition.push({
          kyhieu: { $regex: filter.kyhieu, $options: "i" },
        });
      }
      if (filter.hsx) {
        condition.push({
          hsx: { $regex: filter.hsx, $options: "i" },
        });
      }
      if (filter.mahs) {
        condition.push({
          mahs: { $regex: filter.mahs, $options: "i" },
        });
      }
      if (filter.model) {
        condition.push({
          model: { $regex: filter.model, $options: "i" },
        });
      }
      if (filter.soluuhanh) {
        condition.push({
          soluuhanh: { $regex: filter.soluuhanh, $options: "i" },
        });
      }
      if (filter.cauhinhkythuat) {
        condition.push({
          cauhinhkythuat: { $regex: filter.cauhinhkythuat, $options: "i" },
        });
      }
      if (filter.tbmt) {
        condition.push({
          tbmt: { $regex: filter.tbmt, $options: "i" },
        });
      }
      if (filter.cdt) {
        condition.push({
          cdt: { $regex: filter.cdt, $options: "i" },
        });
      }
      if (filter.sqd) {
        condition.push({
          sqd: { $regex: filter.sqd, $options: "i" },
        });
      }
      if (filter.diadiem) {
        condition.push({
          diadiem: { $regex: filter.diadiem, $options: "i" },
        });
      }
      if (filter.ngayqdFrom || filter.ngayqdTo) {
        const startDate = moment(filter.ngayqdFrom)
          .hours(0)
          .minutes(0)
          .seconds(0);
        const endDate = moment(filter.ngayqdTo)
          .hours(23)
          .minutes(59)
          .seconds(59);
        if (filter.ngayqdFrom && filter.ngayqdTo) {
          condition.push({
            ngayqd: { $gte: startDate, $lte: endDate },
          });
        } else if (filter.timeFrom) {
          condition.push({ ngayqd: { $gte: startDate } });
        } else if (filter.timeTo) {
          condition.push({ ngayqd: { $lte: endDate } });
        }
      }
      return condition;
    },
    Filter: FilterCRHC,
    columns: [
      {
        name: "Tên hóa chất",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_hc,
      },
      {
        name: "ĐVT",
        width: "80px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Khối lượng",
        width: "140px",
        reorder: true,
        right: true,
        sortable: true,
        selector: (row) => row.soluong,
        format: (row) => numeralCustom(row.soluong).format(),
      },
      {
        name: "Đơn giá",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Xuất xứ",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.xuatxu,
      },
      {
        name: "Nhãn hiệu",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhanhieu,
      },
      {
        name: "Ký mã hiệu",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.kyhieu,
      },
      {
        name: "Hãng sản xuất",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hsx,
      },
      {
        name: "Mã hồ sơ",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.mahs,
      },
      {
        name: "Chủng loại",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.model,
      },
      {
        name: "Số lưu hành",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soluuhanh,
      },
      {
        name: "Năm sản xuất",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.namsx,
        format: (row) => formatDateDisplay(row.namsx, "DD/MM/YYYY"),
      },
      {
        name: "Cấu hình",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cauhinhkythuat,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "220px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.sqd,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayqd,
        format: (row) => formatDateDisplay(row.ngayqd, "DD/MM/YYYY"),
      },
      {
        name: "Số nhà thầu tham dự",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  cr_hoatchat: {
    title: "Hoạt chất",
    formTitle: "hoạt chất",
    apiCode: "cr_hoatchat",
    fastFields: [{ label: "Tên hóa chất", value: "hoachat" }],
    Filter: FilterCRHoatchat,
    generateCondition(filter) {
      const condition = [];
      if (filter.hoatchat) {
        condition.push({
          hoatchat: { $regex: filter.hoatchat, $options: "i" },
        });
      }
      return condition;
    },
    columns: [
      {
        name: "Tên hoạt chất",
        reorder: true,
        selector: (row) => row.hoatchat,
      },
    ],
  },
  cr_nhomthuoc: {
    title: "Nhóm thuốc",
    formTitle: "nhóm thuốc",
    apiCode: "cr_nhomthuoc",
    fastFields: [{ label: "Nhóm thuốc", value: "nhomthuoc" }],
    Filter: FilterCRNhomthuoc,
    generateCondition(filter) {
      const condition = [];
      if (filter.nhomthuoc) {
        condition.push({
          nhomthuoc: { $regex: filter.nhomthuoc, $options: "i" },
        });
      }
      return condition;
    },
    columns: [
      {
        name: "Tên nhóm thuốc",
        reorder: true,
        selector: (row) => row.nhomthuoc,
      },
    ],
  },
  cr_duongdung: {
    title: "Đường dùng",
    formTitle: "đường dùng",
    apiCode: "cr_duongdung",
    fastFields: [{ label: "Đường dùng", value: "duongdung" }],
    Filter: FilterCRDuongdung,
    generateCondition(filter) {
      const condition = [];
      if (filter.duongdung) {
        condition.push({
          duongdung: { $regex: filter.duongdung, $options: "i" },
        });
      }
      return condition;
    },
    columns: [
      {
        name: "Đường dùng",
        reorder: true,
        selector: (row) => row.duongdung,
      },
    ],
  },
  cr_nsx: {
    title: "Nước sản xuất",
    formTitle: "nước sản xuất",
    apiCode: "cr_nsx",
    fastFields: [{ label: "Nước sản xuất", value: "nsx" }],
    Filter: FilterCRNsx,
    generateCondition(filter) {
      const condition = [];
      if (filter.nsx) {
        condition.push({
          nsx: { $regex: filter.nsx, $options: "i" },
        });
      }
      return condition;
    },
    columns: [
      {
        name: "Nước sản xuất",
        reorder: true,
        selector: (row) => row.nsx,
      },
    ],
  },
  cr_tt_thuoc: {
    title: "KQTT thuốc",
    formTitle: "thuốc",
    formWidth: "1000px",
    apiCode: "cr_tt_thuoc",
    fields: [
      {
        label: "ID BV",
        value: "id",
      },
      {
        label: "Phân lô",
        value: "lo",
      },
      {
        label: "Hoạt chất",
        value: "hoatchat",
      },
      {
        label: "Tên thương mại",
        value: "tenthuongmai",
      },
      {
        label: "Nồng độ",
        value: "hamluong",
      },
      {
        label: "Mã nhà thầu",
        value: "manhathau",
      },
      {
        label: "Nhà thầu",
        value: "nhathau",
      },
      {
        label: "ĐVT",
        value: "dvt",
      },
      {
        label: "Nhà sản xuất",
        value: "nsx",
      },
      {
        label: "Nước sản xuất",
        value: "nuocsx",
      },

      {
        label: "Visa / GPNK",
        value: "visa",
      },
      {
        label: "Quy cách",
        value: "quycach",
      },
      {
        label: "Nhóm thuốc",
        value: "nhomthuoc",
      },
    ],
    fastFields: [
      {
        label: "ID BV",
        value: "id",
      },
      {
        label: "Phân lô",
        value: "lo",
      },
      {
        label: "Hoạt chất",
        value: "hoatchat",
      },
      {
        label: "Tên thương mại",
        value: "tenthuongmai",
      },
      {
        label: "Nồng độ",
        value: "hamluong",
      },
      {
        label: "Mã nhà thầu",
        value: "manhathau",
      },
      {
        label: "Nhà thầu",
        value: "nhathau",
      },
      {
        label: "ĐVT",
        value: "dvt",
      },
      {
        label: "Nhà sản xuất",
        value: "nsx",
      },
      {
        label: "Nước sản xuất",
        value: "nuocsx",
      },

      {
        label: "Visa / GPNK",
        value: "visa",
      },
      {
        label: "Quy cách",
        value: "quycach",
      },
      {
        label: "Nhóm thuốc",
        value: "nhomthuoc",
      },
    ],
    columns: [
      {
        name: "ID BV",
        reorder: true,
        selector: (row) => row.id,
        width: "100px",
        wrap: true,
      },
      {
        name: "Phân lô",
        reorder: true,
        selector: (row) => row.lo,
        width: "150px",
        wrap: true,
      },
      {
        name: "Hoạt chất",
        reorder: true,
        selector: (row) => row.hoatchat,
        width: "150px",
        wrap: true,
      },
      {
        name: "Tên thương mại",
        reorder: true,
        selector: (row) => row.tenthuongmai,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nồng độ",
        reorder: true,
        selector: (row) => row.hamluong,
        width: "150px",
        wrap: true,
      },
      {
        name: "Mã nhà thầu",
        reorder: true,
        selector: (row) => row.manhathau,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhà thầu",
        reorder: true,
        selector: (row) => row.nhathau,
        width: "150px",
        wrap: true,
      },
      {
        name: "ĐVT",
        reorder: true,
        selector: (row) => row.dvt,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhà sản xuất",
        reorder: true,
        selector: (row) => row.nsx,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nước sản xuất",
        reorder: true,
        selector: (row) => row.nuocsx,
        width: "150px",
        wrap: true,
      },
      {
        name: "Số lượng",
        reorder: true,
        selector: (row) => row.sl,
        width: "150px",
        wrap: true,
      },
      {
        name: "Hạn sử dụng",
        reorder: true,
        selector: (row) => row.hsd,
        width: "150px",
        wrap: true,
      },
      {
        name: "Giá trúng thầu",
        reorder: true,
        selector: (row) => row.giatrungthau,
        width: "150px",
        wrap: true,
      },
      {
        name: "Visa / GPNK",
        reorder: true,
        selector: (row) => row.visa,
        width: "150px",
        wrap: true,
      },
      {
        name: "Quy cách",
        reorder: true,
        selector: (row) => row.quycach,
        width: "150px",
        wrap: true,
      },
      {
        name: "Giá KK/KKL",
        reorder: true,
        selector: (row) => row.giakk,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhóm thuốc",
        reorder: true,
        selector: (row) => row.nhomthuoc,
        width: "150px",
        wrap: true,
      },
    ],
  },
  cr_tt_vthc: {
    title: "KQTT vật tư, hóa chất",
    formTitle: "thuốc",
    formWidth: "1000px",
    apiCode: "cr_tt_vthc",
    fields: [
      {
        label: "ID BV",
        value: "id",
      },
      {
        label: "Phân lô",
        value: "lo",
      },
      {
        label: "Tên mời thầu",
        value: "tenmoithau",
      },
      {
        label: "Tên thương mại",
        value: "tenthuongmai",
      },
      {
        label: "Mã hiệu SP",
        value: "mahieusp",
      },
      {
        label: "Mã nhà thầu",
        value: "manhathau",
      },
      {
        label: "Nhà thầu",
        value: "nhathau",
      },
      {
        label: "ĐVT",
        value: "dvt",
      },
      {
        label: "Nhà sản xuất",
        value: "nsx",
      },
      {
        label: "Nước sản xuất",
        value: "nuocsx",
      },

      {
        label: "Pháp lý sản phẩm",
        value: "visa",
      },
      {
        label: "Quy cách",
        value: "quycach",
      },
      {
        label: "Kiểm soát chất lượng",
        value: "kiemsoat",
      },
      {
        label: "Yêu cầu kỹ thuật",
        value: "yckt",
      },
      {
        label: "Nhóm kỹ thuật",
        value: "nhomkt",
      },
      {
        label: "Tên bao bì",
        value: "tenbaobi",
      },
      {
        label: "Mã dùng chung",
        value: "madungchung",
      },
      {
        label: "Chủ sở hữu",
        value: "csh",
      },
    ],
    fastFields: [
      {
        label: "ID BV",
        value: "id",
      },
      {
        label: "Phân lô",
        value: "lo",
      },
      {
        label: "Tên mời thầu",
        value: "tenmoithau",
      },
      {
        label: "Tên thương mại",
        value: "tenthuongmai",
      },
      {
        label: "Mã hiệu SP",
        value: "mahieusp",
      },
      {
        label: "Mã nhà thầu",
        value: "manhathau",
      },
      {
        label: "Nhà thầu",
        value: "nhathau",
      },
      {
        label: "ĐVT",
        value: "dvt",
      },
      {
        label: "Nhà sản xuất",
        value: "nsx",
      },
      {
        label: "Nước sản xuất",
        value: "nuocsx",
      },

      {
        label: "Pháp lý sản phẩm",
        value: "visa",
      },
      {
        label: "Quy cách",
        value: "quycach",
      },
      {
        label: "Kiểm soát chất lượng",
        value: "kiemsoat",
      },
      {
        label: "Yêu cầu kỹ thuật",
        value: "yckt",
      },
      {
        label: "Nhóm kỹ thuật",
        value: "nhomkt",
      },
      {
        label: "Tên bao bì",
        value: "tenbaobi",
      },
      {
        label: "Mã dùng chung",
        value: "madungchung",
      },
      {
        label: "Chủ sở hữu",
        value: "csh",
      },
    ],
    columns: [
      {
        name: "ID BV",
        reorder: true,
        selector: (row) => row.id,
        width: "100px",
        wrap: true,
      },
      {
        name: "Phân lô",
        reorder: true,
        selector: (row) => row.lo,
        width: "150px",
        wrap: true,
      },
      {
        name: "Tên mời thầu",
        reorder: true,
        selector: (row) => row.tenmoithau,
        width: "150px",
        wrap: true,
      },
      {
        name: "Tên thương mại",
        reorder: true,
        selector: (row) => row.tenthuongmai,
        width: "150px",
        wrap: true,
      },
      {
        name: "Mã hiệu SP",
        reorder: true,
        selector: (row) => row.mahieusp,
        width: "150px",
        wrap: true,
      },
      {
        name: "Mã nhà thầu",
        reorder: true,
        selector: (row) => row.manhathau,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhà thầu",
        reorder: true,
        selector: (row) => row.nhathau,
        width: "150px",
        wrap: true,
      },
      {
        name: "ĐVT",
        reorder: true,
        selector: (row) => row.dvt,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhà sản xuất",
        reorder: true,
        selector: (row) => row.nsx,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nước sản xuất",
        reorder: true,
        selector: (row) => row.nuocsx,
        width: "150px",
        wrap: true,
      },
      {
        name: "Số lượng",
        reorder: true,
        selector: (row) => row.sl,
        width: "150px",
        wrap: true,
      },
      {
        name: "Hạn sử dụng",
        reorder: true,
        selector: (row) => row.hsd,
        width: "150px",
        wrap: true,
      },
      {
        name: "Giá trúng thầu",
        reorder: true,
        selector: (row) => row.giatrungthau,
        width: "150px",
        wrap: true,
      },
      {
        name: "Pháp lý SP",
        reorder: true,
        selector: (row) => row.visa,
        width: "150px",
        wrap: true,
      },
      {
        name: "Quy cách",
        reorder: true,
        selector: (row) => row.quycach,
        width: "150px",
        wrap: true,
      },
      {
        name: "Giấy phép bán hàng",
        reorder: true,
        selector: (row) => row.giayphep,
        width: "180px",
        wrap: true,
      },
      {
        name: "Kiểm soát chất lượng",
        reorder: true,
        selector: (row) => row.kiemsoat,
        width: "200px",
        wrap: true,
      },
      {
        name: "Yêu cầu kỹ thuật",
        reorder: true,
        selector: (row) => row.yckt,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhóm kỹ thuật",
        reorder: true,
        selector: (row) => row.nhomkt,
        width: "150px",
        wrap: true,
      },
      {
        name: "Tên bao bì",
        reorder: true,
        selector: (row) => row.tenbaobi,
        width: "150px",
        wrap: true,
      },
      {
        name: "Mã dùng chung",
        reorder: true,
        selector: (row) => row.madungchung,
        width: "150px",
        wrap: true,
      },
      {
        name: "Chủ sở hữu",
        reorder: true,
        selector: (row) => row.csh,
        width: "150px",
        wrap: true,
      },
    ],
  },
  fos_tonghopgiacr: {
    title: 'Tổng hợp kết quả trúng thầu',
    apiCode: 'fos_tonghopgiacr',
    formTitle: "thuốc",
    formWidth: "1000px",
    fields: [],
    fastFields: [],
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thuốc",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_thuoc,
      },
      {
        name: "Đơn giá",
        width: "130px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hoat_chat,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hamluong,
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.gdklh,
      },
      {
        name: "Đường dùng",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.duongdung,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.baoche,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhomthuoc,
      },
      {
        name: "Cơ sở SX",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cssx,
      },
      {
        name: "Nước SX",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nuocsx,
      },
      {
        name: "Quy cách",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.quycach,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Số lượng",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "210px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soquyetdinh,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayquyetdinh,
        format: (row) => formatDateDisplay(row.ngayquyetdinh, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
        format: (row) => numeralCustom(row.slnhathau).format(),
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
  dmvt: {
    title: "Hang hoa",
    formTitle: "hang hoa",
    formWidth: "1000px",
    apiCode: "dmvt",
    columns: [
      {
        name: "Ten hang",
        selector: (row) => row.ten_vt,
      },
    ],
  },
};

export { lists };
